import React, { useEffect, lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useHistory, Switch, Route } from 'react-router-dom';
import './assets/css/app.less';
import { ConfigProvider as ArcoConfigProvider } from '@arco-design/web-react';
import enUS from '@arco-design/web-react/es/locale/en-US';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import { ConfigProvider as AntdConfigProvider } from 'antd';
import antdZhCN from 'antd/es/locale/zh_CN';
import antdEnUS from 'antd/es/locale/en_US';
// import { UserTerms } from '@/pages/clause/UserTerms';
import { App } from './App';
import { initStarling, isLangZH } from './common/starling';

window.MENU_STATE = { openKeys: [] };

const UserTerms = lazy(() => import('@/pages/clause/UserTerms'));

// 先注释starling 我们这个国际化方案应该使用【friday项目的方案】
// setLocale('zh-CN');
// 切换路由时此组件不刷新
const AppWrapper: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    // 访问根路径的逻辑（part1），只在页面加载时执行一次
    if (window.location.pathname === '/') {
      // 兼容老的 hash 路由
      if (window.location.hash) {
        history.replace(window.location.hash.substr(1));
      } else {
        const path = localStorage.getItem('redirect_path');
        if (path) {
          //   localStorage.removeItem('redirect_path');
          history.replace(path);
        }
      }
    }
  }, []);
  // const App = require('./App.tsx').default;
  return <App />;
};
(async () => {
  try {
    await initStarling();
  } catch {
  } finally {
    /** 为了修复staling 国际化常量问题  https://site.bytedance.net/docs/5704/10753/188271/  */
    ReactDOM.render(
      <BrowserRouter>
        <ArcoConfigProvider locale={isLangZH ? zhCN : enUS}>
          <AntdConfigProvider locale={isLangZH ? antdZhCN : antdEnUS}>
            <Suspense fallback={'...'}>
              <Switch>
                {/* 用户服务条款 和隐私政策 纯展示不写在 AppWrapper里面 */}
                <Route
                  component={UserTerms}
                  key={'terms'}
                  path="/terms"
                  exact={true}
                />
                <Route
                  component={lazy(() => import('@/pages/clause/PrivacyPolicy'))}
                  key={'privacy-policy'}
                  path="/privacy-policy"
                  exact={true}
                />
                {/* 外部用户邮箱绑定 不写在  AppWrapper里面 */}
                <Route
                  component={lazy(() => import('@/pages/AppiyMail/index'))}
                  key={'apply-mail'}
                  path="/apply-mail"
                  exact={true}
                />
                <AppWrapper />
              </Switch>
            </Suspense>
            {/* {!location.pathname.includes('/terms') ? <AppWrapper /> : null} */}
          </AntdConfigProvider>
        </ArcoConfigProvider>
      </BrowserRouter>,
      document.getElementById('root'),
    );
  }
})();
